import TileSeriesLink from './TileSeriesLink'

export default TileSeriesLink
// eslint-disable-next-line import/export
export * from './TileSeriesLink'
